module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/trainings.json
// module id = 1511
// module chunks = 157337347199805